import { render, staticRenderFns } from "./cards-list-item-ligne-panier.vue?vue&type=template&id=67e83428&scoped=true&"
import script from "./cards-list-item-ligne-panier.vue?vue&type=script&lang=js&"
export * from "./cards-list-item-ligne-panier.vue?vue&type=script&lang=js&"
import style0 from "./cards-list-item-ligne-panier.vue?vue&type=style&index=0&id=67e83428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e83428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDivider,VIcon,VSelect})
